<template>
  <div class="scroll module-detail-container">
    <!-- 主内容区 -->
    <div class="module-content" v-if="!show">
      <!-- 1. 模块专属图片 -->
      <div class="module-specific-image">
        <img :src="currentModule.url" :alt="currentModule.title" />
        <el-button @click="addViper" class="joinBtn">申请加入</el-button>
      </div>
      <div class="linkBox">
        <div class="linkCard" v-for="item in government">
          <div class="linkCard_content">
            <div class="linkCard_content_img">
              <img :src="item.url" alt="" />
            </div>
            <p class="title">{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <el-collapse-transition v-else>
      <div v-show="show" class="form-card">
        <div>
          <apply-membership
            @submit="handleFormSubmit"
            @cancel="handleFormCancel"
          />
        </div>
      </div>
    </el-collapse-transition>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import applyMembership from '@/views/transactionMatching/component/applyMembership.vue';
import { scrollTop } from '@/util/scrollTop';
import { createTransactionUser } from '@/API/transactionMatching/transactionMatching';
export default {
  components: {
    bottomUrl,
    applyMembership,
  },
  data() {
    return {
      show: false,
      // 8个模块的配置数据
      currentModule: {
        title: '交易撮合',
        url: require('@/assets/recycling/index/jych.png'),
      },
      government: [
        {
          title: '四川省发展和改革委员会',
          url: require('@/assets/recycling/index/logo-省发改委商务厅.png'),
        },
        {
          title: '四川省商务厅',
          url: require('@/assets/recycling/index/logo-省发改委商务厅.png'),
        },
        {
          title: '四川省供销合作社联合社',
          url: require('@/assets/recycling/index/logo-省供销合作社联合社.png'),
        },
        {
          title: '四川省再生资源行业协会',
          url: require('@/assets/recycling/index/logo-天府再生协会.png'),
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleFormSubmit(formData) {
      console.log('表单提交数据：', formData);
      createTransactionUser(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success('申请信息添加成功，请等待审核');
        } else {
          this.$message.error(`申请信息添加失败：${res.msg}`);
        }
        this.show = false;
        scrollTop();
      });
      // 父组件处理提交逻辑
    },
    handleFormCancel() {
      this.show = false;
      scrollTop();
    },
    addViper() {
      if (this.$store.state.ordinaryLoggedIn) {
        this.show = true;
      } else {
        this.$confirm('用户未登录，是否前往首页登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass:'confStyle'
        })
          .then(() => {
            this.$router.push('/');
            this.$store.commit('login/changeLoginDialogVisible', true);
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
.module-detail-container {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 90px);
  overflow-y: auto;
  position: relative;
  background-color: #fafafa;
}

.module-content {
  width: 100%;
  padding-bottom: 32px; /* 为底部组件预留空间 */
}
.form-card {
  min-height: calc(100% - 250px);
}
/* 模块专属图片样式 */
.module-specific-image {
  width: 100%;
  margin: 0 auto 40px;
  display: block;
  position: relative;
}
.joinBtn {
  position: absolute;
  left: 16.5%;
  top: 64%;
  width: 165px;
  color: #1abe6b;
}
.module-specific-image img {
  width: 100%;
  height: 730px;
  object-fit: cover;
}
.linkBox {
  height: 280px;
  width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .linkCard {
    width: 445px;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 5px;
    padding: 20px 0;
    .linkCard_content {
      text-align: center;
      p {
        text-align: center;
        padding-top: 10px;
        font-size: 26px;
        font-weight: 600;
      }
      .linkCard_content_img {
        display: flex;
        justify-content: center;
      }
    }
  }
}

@media (max-width: 768px) {
  .module-detail-container {
    height: auto;
    background-color: transparent;
  }
  .module-content {
    height: 100%;
    padding: 0 16px 180px;
    background-size: 90% auto; /* 移动端适当缩小 */
    .module-specific-image {
      margin-bottom: 72px;
    }
  }

  .joinBtn {
    width:100%;
    left: 0;
    top: calc(100% + 16px);
    height: 40px;
  }
  .linkBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .linkCard_content {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 60px;
      .linkCard_content_img {
        width: 50px;
        height: 50px;
      }
      .title {
        font-size: 12px !important;
        font-weight: normal !important;
      }
    }
  }
}
</style>

<style>

@media screen and (max-width: 768px) {
  .confStyle{
    width:90% !important;
  }
}
</style>
